// extracted by mini-css-extract-plugin
module.exports = {"detailsPanel":"productImages_detailsPanel__2niWU","images":"productImages_images__2ANjX","imageWrapper":"productImages_imageWrapper__38ILu"};